export const POST_CSS = `

  /* ── Progress bar ── */
  .sp-progress {
    position: fixed; top: 0; left: 0; right: 0; z-index: 200;
    height: 2px;
    background: var(--color-divider);
  }
  .sp-progress__bar {
    height: 100%;
    background: var(--color-gold);
    transition: width 0.1s linear;
  }

  /* ── Page ── */
  .sp-page {
    background: var(--color-white);
    min-height: 100vh;
  }

  /* ── Hero ── */
  .sp-hero {
    position: relative;
    height: 76vh;
    min-height: 520px;
    max-height: 800px;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
  }
  @media (max-width: 640px) {
    .sp-hero { height: 65vh; min-height: 360px; }
  }
  .sp-hero__img-wrap {
    position: absolute; inset: 0;
  }
  .sp-hero__img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
  }
  .sp-hero__img-fallback {
    width: 100%; height: 100%;
    background: linear-gradient(160deg, var(--color-midnight) 0%, #0a3d55 100%);
  }
  .sp-hero__vignette {
    position: absolute; inset: 0;
    background: linear-gradient(
      to top,
      rgba(7,30,48,0.80)  0%,
      rgba(7,30,48,0.42)  35%,
      rgba(7,30,48,0.10)  70%,
      rgba(7,30,48,0)    100%
    );
  }
  .sp-hero__content {
    position: relative; z-index: 2;
    padding: 0 6vw 56px;
    width: 100%;
  }
  .sp-hero__cat {
    display: inline-block;
    font-family: var(--font-sans);
    font-size: 9px; font-weight: 500;
    letter-spacing: 0.22em; text-transform: uppercase;
    color: var(--color-gold);
    border: 1px solid rgba(201,165,106,0.4);
    padding: 4px 12px;
    margin-bottom: 20px;
  }
  .sp-hero__title {
    font-family: var(--font-serif);
    font-size: clamp(2.4rem, 5.5vw, 4.8rem);
    font-weight: 300;
    line-height: 1.1;
    color: var(--color-ivory);
    margin: 0 0 20px;
  }
  .sp-hero__meta {
    font-family: var(--font-sans);
    font-size: 11px; font-weight: 400;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: rgba(245,242,236,0.5);
    display: flex; gap: 16px;
  }

  /* ── Layout ── */
  .sp-layout {
    display: grid;
    grid-template-columns: 1fr 260px;
    gap: 0 64px;
    max-width: 1160px;
    margin: 0 auto;
    padding: 64px 6vw 100px;
    align-items: start;
  }
  .sp-sidebar {
    position: relative;
    align-self: stretch;
  }
  @media (max-width: 960px) {
    .sp-layout {
      grid-template-columns: 1fr;
      gap: 0;
      padding: 48px 6vw 80px;
    }
    .sp-sidebar { display: none; }
  }

  /* ── Breadcrumb bar ── */
  .sp-breadcrumb-bar {
    max-width: 1160px;
    margin: 0 auto;
    padding: 28px 6vw 0;
    border-bottom: 1px solid var(--color-divider);
    padding-bottom: 20px;
  }

  /* ── Article content ── */
  .sp-content {
    font-family: var(--font-sans);
    font-size: 17px;
    font-weight: 300;
    line-height: 1.85;
    color: var(--color-charcoal);
    max-width: 720px;
  }

  /* Drop cap */
  .sp-content > p:first-of-type::first-letter {
    font-family: var(--font-serif);
    font-size: 5.2em;
    font-weight: 400;
    line-height: 0.78;
    float: left;
    margin: 6px 12px 0 0;
    color: var(--color-teal);
  }

  .sp-content p {
    margin: 0 0 1.6em;
  }

  .sp-content h2 {
    font-family: var(--font-serif);
    font-size: clamp(1.6rem, 2.8vw, 2.2rem);
    font-weight: 400;
    color: var(--color-midnight);
    margin: 1em 0 0.6em;
    padding-top: 1.2em;
    border-top: 1px solid var(--color-divider);
    line-height: 1.2;
  }

  .sp-content h3 {
    font-family: var(--font-serif);
    font-size: clamp(1.2rem, 2vw, 1.55rem);
    font-weight: 400;
    font-style: italic;
    color: var(--color-midnight);
    margin: 2em 0 0.5em;
    line-height: 1.3;
  }

  .sp-content ul, .sp-content ol {
    padding-left: 0;
    margin: 0 0 1.6em;
    list-style: none;
  }
  .sp-content ul li, .sp-content ol li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 0.5em;
  }
  .sp-content ul li::before {
    content: '—';
    position: absolute; left: 0;
    color: var(--color-gold);
    font-weight: 300;
  }
  .sp-content ol { counter-reset: sp-ol; }
  .sp-content ol li::before {
    counter-increment: sp-ol;
    content: counter(sp-ol) '.';
    position: absolute; left: 0;
    color: var(--color-gold);
    font-size: 12px;
    font-weight: 500;
    top: 3px;
  }

  /* Pull quote / blockquote */
  .sp-content blockquote {
    margin: 2.4em 0;
    padding: 28px 36px;
    border-left: 3px solid var(--color-gold);
    background: var(--color-ivory);
    position: relative;
  }
  .sp-content blockquote p {
    font-family: var(--font-serif);
    font-size: 1.4rem;
    font-style: italic;
    font-weight: 300;
    line-height: 1.55;
    color: var(--color-midnight);
    margin: 0;
  }
  .sp-content blockquote::before {
    content: '\\201C';
    font-family: var(--font-serif);
    font-size: 5rem;
    color: var(--color-gold);
    opacity: 0.3;
    position: absolute;
    top: -10px; left: 24px;
    line-height: 1;
  }

  /* Images inside content */
  .sp-content img {
    width: calc(100% + 80px);
    max-width: calc(100% + 80px);
    margin-left: -40px;
    display: block;
    height: auto;
    margin-top: 2em;
    margin-bottom: 2em;
  }
  @media (max-width: 640px) {
    .sp-content img {
      width: calc(100% + 12vw);
      max-width: calc(100% + 12vw);
      margin-left: -6vw;
    }
  }

  .sp-content a {
    color: var(--color-teal);
    text-decoration: underline;
    text-decoration-color: var(--color-teal-divider);
    text-underline-offset: 3px;
    transition: text-decoration-color 0.2s;
  }
  .sp-content a:hover { text-decoration-color: var(--color-teal); }

  .sp-content strong { font-weight: 500; color: var(--color-midnight); }
  .sp-content em { font-style: italic; }

  /* ── Sidebar ── */
  .sp-sidebar__sticky {
    position: sticky;
    top: 80px;
    max-height: calc(100vh - 64px);
    overflow-y: auto;
    scrollbar-width: none;
  }
  .sp-sidebar__sticky::-webkit-scrollbar { display: none; }

  /* TOC */
  .sp-toc__label {
    font-family: var(--font-sans);
    font-size: 9px; font-weight: 500;
    letter-spacing: 0.2em; text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 16px;
  }
  .sp-toc__list {
    list-style: none;
    padding: 0; margin: 0;
    border-left: 1px solid var(--color-divider);
  }
  .sp-toc__item {
    padding: 0;
  }
  .sp-toc__item a {
    display: block;
    padding: 6px 0 6px 16px;
    font-family: var(--font-sans);
    font-size: 12px; font-weight: 400;
    line-height: 1.4;
    color: var(--color-slate);
    text-decoration: none;
    border-left: 2px solid transparent;
    margin-left: -1px;
    transition: color 0.2s, border-color 0.2s;
  }
  .sp-toc__item a:hover { color: var(--color-teal); }
  .sp-toc__item--active a {
    color: var(--color-teal);
    border-left-color: var(--color-teal);
  }
  .sp-toc__item--h3 a {
    padding-left: 28px;
    font-size: 11px;
    opacity: 0.8;
  }

  .sp-sidebar__rule {
    border: none;
    border-top: 1px solid var(--color-divider);
    margin: 28px 0;
  }

  .sp-back-link {
    font-family: var(--font-sans);
    font-size: 11px; font-weight: 500;
    letter-spacing: 0.08em; text-transform: uppercase;
    color: var(--color-slate);
    text-decoration: none;
    transition: color 0.2s;
  }
  .sp-back-link:hover { color: var(--color-teal); }

  /* ── Related posts ── */
  .sp-related-wrap {
    max-width: 1160px;
    margin: 0 auto;
    padding: 0 6vw 100px;
  }

  .sp-related {
    border-top: 1px solid var(--color-divider);
    padding-top: 56px;
  }
  .sp-related__header {
    display: flex; align-items: center; gap: 20px;
    margin-bottom: 8px;
  }
  .sp-related__label {
    font-family: var(--font-sans);
    font-size: 9px; font-weight: 500;
    letter-spacing: 0.22em; text-transform: uppercase;
    color: var(--color-gold);
    white-space: nowrap;
  }
  .sp-related__rule {
    flex: 1;
    height: 1px;
    background: var(--color-divider);
  }

  .sp-related__list {
    list-style: none; padding: 0; margin: 0;
  }
  .sp-related__item {
    display: flex; align-items: center; gap: 20px;
    padding: 16px 0;
    border-bottom: 1px solid var(--color-divider);
  }
  .sp-related__body {
    flex: 1; min-width: 0;
    display: flex; flex-direction: column; gap: 5px;
  }
  .sp-related__date {
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 400;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--color-gold);
    opacity: 0.8;
  }
  .sp-related__title {
    font-family: var(--font-serif);
    font-size: clamp(1rem, 1.6vw, 1.2rem);
    font-weight: 400;
    color: var(--color-charcoal);
    text-decoration: none;
    line-height: 1.35;
    transition: color 0.2s;
  }
  .sp-related__title:hover { color: var(--color-teal); }

  .sp-related__arrow {
    display: flex; align-items: center; justify-content: center;
    width: 28px; height: 28px;
    border: 1px solid var(--color-divider);
    color: var(--color-slate);
    text-decoration: none;
    transition: border-color 0.2s, color 0.2s, background 0.2s;
  }
  .sp-related__arrow:hover {
    border-color: var(--color-teal);
    color: var(--color-teal);
  }
`
